// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { poRegex } from "@guestsupply/XDL/constants";

const regex = {
    digit: /(?=.*\d)/g,
    lowerCase: /(?=.*[a-z])/g,
    upperCase: /(?=.*[A-Z])/g,
    nonAlphaNumaric: /(?=.*[^A-Za-z0-9\s])/g,
};

const validatePasswordRequirements = (
    password: string,
    passwordMinLength: number,
    checkDigits: boolean,
    checkLowerCase: boolean,
    checkUpperCase: boolean,
    checkNonAlphaNumarics: boolean,
) => {
    return {
        hasLowerCase: checkLowerCase ? regex.lowerCase.test(password) : true,
        hasUpperCase: checkUpperCase ? regex.upperCase.test(password) : true,
        hasNonAlphanumaric: checkNonAlphaNumarics ? regex.nonAlphaNumaric.test(password) : true,
        hasDigit: checkDigits ? regex.digit.test(password) : true,
        hasMoreThanEightCharachters: password?.length >= passwordMinLength || false,
    };
};

export default validatePasswordRequirements;
